<svg xmlns="http://www.w3.org/2000/svg" width="26" height="18" viewBox="0 0 26 18">
  <path id="background_graph" data-name="background graph" d="M1,1H5V17H1ZM11,1h4V17H11ZM21,1h4V17H21ZM0,0V18H26V0Z" fill="#3c3c3b"/>
</svg>
